import { Action } from 'redux'
import { SHOPPING_BASKET_WIZARD_ORDER_MUTATION_FINISHED } from '../../../constants/shoppingBasketConstants'

export interface MarkOrderMutationFinished
  extends Action<typeof SHOPPING_BASKET_WIZARD_ORDER_MUTATION_FINISHED> {}

export const markOrderMutationFinished = () => ({
  type: SHOPPING_BASKET_WIZARD_ORDER_MUTATION_FINISHED,
})
